module.exports = __webpack_public_path__ + "img/logoA.820f5dde.png";